import { INVENTORY_ITEMS_DETAILS } from '../actionTypes';

export const fetchInventoryItemDetails = (action) => ({
  type: INVENTORY_ITEMS_DETAILS.FETCH,
  payload: action.payload,
});
